import React, { Component } from 'react';
import Button from '@material-ui/core/Button';

export class Branches extends Component {
    static displayName = Branches.name;

    render() {
        return (
            <div>
                <Button variant="contained" color="primary">
                    1
                </Button>
                <Button variant="contained" color="primary">
                    2
                </Button>
                <Button variant="contained" color="primary">
                    3
                </Button>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/Branches.js